import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import type { InputData } from '@clean-code/models';
import { ProgressBarComponent } from '@clean-code/shared/components/ui-progress-bar';
import { MarketDetailsComponent } from '@clean-code/time-series-identifier/ui-details';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { TranslocoModule } from '@jsverse/transloco';
import { BehaviorSubject } from 'rxjs';

@Component({
    templateUrl: './table-widget-details-dialog.component.html',
    styleUrls: ['./table-widget-details-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        MatProgressBarModule,
        MatDialogModule,
        FontAwesomeModule,
        TranslocoModule,
        ProgressBarComponent,
        MarketDetailsComponent,
    ]
})
export class TableDetailsDialogComponent {
  private _faTimes = faTimes;

  public get faTimes() {
    return this._faTimes;
  }
  public set faTimes(value) {
    this._faTimes = value;
  }
  public isLoading$ = new BehaviorSubject<boolean>(false);

  constructor(
    public dialogRef: MatDialogRef<TableDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      dataSource: InputData;
      name: string;
      hideClosingValueHeader: boolean;
    },
  ) {}
}
